const theme = {
  name: "UAE Business Setup Online | Compare Business Packages",
  fullName: "Looking to start a business in Dubai? Start with MyUAEStartup.com — a digital-first UAE business setup consultancy offering licensing, visas & PRO services. Fast approvals, transparent pricing, expert support.",
  url: "",
  author: {
    name: "My UAE",
    profile_url_fb: "https://www.facebook.com/people/My-UAE/61580809689340/",
    profile_url_twitter: "https://x.com/Myuaestartup",
    profile_url_youtube:"https://www.youtube.com/@MyuaeStartup",
    profile_url_instagram:"https://www.instagram.com/myuaestartup/",
    profile_url_linkedin:"https://www.linkedin.com/company/myuaestartup/",
    profile_url_pinterest:"https://www.pinterest.com/myuaestartup/",
  },
  contacts: {
    company:"My Startup L.L.C-FZ",

    address: "Business Center 1, M Floor, The Meydan Hotel, Nad Al Sheba, Dubai, U.A.E.",
    email: "info@myuaestartup.com",
    phone: "+971 - 586098408",
  },
};

export default theme;
